import { useTranslation } from "@redotech/redo-i18n";
import { viewTypes } from "@redotech/redo-views-common/views";
import { memo } from "react";
import {
  RedoModal,
  RedoModalButtonProps,
} from "./arbiter-components/modal/redo-modal";

export const DeleteTableViewModal = memo(function DeleteTableViewModal({
  open,
  setOpen,
  view,
  onDelete,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  view: viewTypes[keyof viewTypes];
  onDelete: () => void;
}) {
  const { t } = useTranslation();
  const primaryButtonProps: RedoModalButtonProps = {
    onClick: onDelete,
    text: t("Delete"),
  };

  const secondaryButtonProps: RedoModalButtonProps = {
    onClick: () => setOpen(false),
    text: t("Cancel"),
  };

  const modalTitle = t("Delete view - {{viewName}}", { viewName: view.name });

  return (
    <RedoModal
      isOpen={open}
      onModalCloseRequested={() => setOpen(false)}
      primaryButton={primaryButtonProps}
      secondaryButton={secondaryButtonProps}
      subtitle={t("Are you sure you want to delete this view?")}
      theme="error"
      title={modalTitle}
    />
  );
});
